import { render } from "./ConsultView.vue?vue&type=template&id=2b89cc62&scoped=true&ts=true"
import script from "./ConsultView.vue?vue&type=script&lang=ts"
export * from "./ConsultView.vue?vue&type=script&lang=ts"

import "./ConsultView.vue?vue&type=style&index=0&id=2b89cc62&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b89cc62"]])

export default __exports__